<template>
  <Modal
    title="Uploading Photos"
    no-submit
    prevent-close
    @hide-modal="emit('hide-modal')"
  >
    <div class="section-spacing-20">
      <div class="flex flex-col md:flex-row md:items-end justify-between gap-3">
        <div>
          <div>Your Progress</div>
          <div class="font-lg">
            <strong>{{ progress.toFixed() }}% Completed</strong>
          </div>
        </div>
        <div class="d-flex">
          <Spinner
            :message="`Uploading ${photoCount} photo(s) / ${fileSize({
              size: totalFileSize
            })} total`"
            class="mr-2"
          />
        </div>
      </div>
      <ProgressBar :progress="progress" />
      <div>
        <strong>
          Notice: If you close this window before the upload completes some
          photos may be lost.
        </strong>
      </div>
      <div>
        If you need to continue working you can
        <a href="#" target="_blank">open another tab</a> and come back to this
        one in a few minutes.
      </div>
    </div>
    <template #delete>
      <div class="d-flex justify-content-start">
        <Button type="secondary" @click="emit('hide-modal')"
          >Cancel Upload</Button
        >
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import Spinner from "@/components/Spinner.vue";

const emit = defineEmits(["hide-modal"]);
defineProps<{
  progress: number;
  photoCount: number;
  totalFileSize: number;
}>();
</script>

<style lang="scss" scoped>
.font-lg {
  font-size: 1.3em;
}
:deep(.progress-bar-container) {
  height: 1em;
}
:deep(.progress-details) {
  display: none !important;
}
</style>
